import { Workstream } from "./Plan"
import WorkPackageObj from "./WorkPackageObj"
import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import { dateformat } from "@/utils/GlobalConstants"
import { formatDate } from "date-fns"
import { ChevronRightIcon, ChevronUpIcon, WorkstreamIcon } from "../ui/Icons/TooltipIcon"
import { WorkstreamProgressChartRow } from "../WorkstreamProgressChart"
import GanttObj from "./plan_gantt/GanttObj"
import { WorkPackageContextMenu } from "./context_menus/workPackage_menu"

interface WorkstreamProps {
    workstream: Workstream
    onClick: (workstream: Workstream) => void
    selected?: boolean
    open?: boolean
    projectTypeId: number
    showChart: boolean
    showGantt?: boolean
}

const WorkstreamObj = ({ workstream, onClick, selected, open, projectTypeId, showChart, showGantt: showGannt }: WorkstreamProps) => {
    const props = useContext(PlanBuilderContext);

    if (!workstream) {
        return <div className="text-red-500">Workstream not found</div>;
    }
    function toggle(e: React.MouseEvent<HTMLButtonElement>) {
        props.toggleWorkstream(workstream.id);
        e.stopPropagation();
    }

    function getDateRange() {
        if (workstream.workPackages.length === 0) {
            return "No work packages";
        }
        // get earliest start date and latest finish date of all workpackages
        const startDate = getStartDate();
        const finishDate = getFinishDate();
        return formatDate(startDate, dateformat) + " - " + formatDate(finishDate, dateformat);
    }


    function getStartDate() {
        if (workstream.workPackages.length === 0) {
            return new Date();
        }
        const startDate = workstream.workPackages.reduce((earliest, workpackage) => {
            return workpackage.startDate < earliest ? workpackage.startDate : earliest;
        }, workstream.workPackages[0].startDate);
        return startDate;
    }

    function getFinishDate() {
        if (workstream.workPackages.length === 0) {
            return new Date();
        }
        const finishDate = workstream.workPackages.reduce((latest, workpackage) => {
            return workpackage.finishDate > latest ? workpackage.finishDate : latest;
        }, workstream.workPackages[0].finishDate);
        return finishDate;
    }

    function getActualPercentage() {
        const totalTasks = workstream.workPackages.reduce((total, workPackage) => {
            return total + workPackage.tasks.length;
        }, 0);
        if (totalTasks === 0) return 0;
        const completedTasks = workstream.workPackages.reduce((total, workPackage) => {
            return total + workPackage.tasks.filter(task => task.completed).length;
        }, 0);
        return Math.round((completedTasks / totalTasks) * 100);
    }

    function getPlannedPercentage() {
        const totalTasks = workstream.workPackages.reduce((total, workPackage) => {
            return total + workPackage.tasks.length;
        }, 0);

        if (totalTasks === 0) return 0;

        const plannedTasks = workstream.workPackages.reduce((total, workPackage) => {
            return total + workPackage.tasks.filter(task => new Date(task.finishDate).setHours(0, 0, 0) <= new Date().setHours(0, 0, 0)).length;
        }, 0);
        return Math.round((plannedTasks / totalTasks) * 100);
    }

    return (
        <div className="flex flex-col">
            {projectTypeId === 2 && (
                <div id={"ws" + workstream.id} className={"flex flex-row text-planbuilder-workstream-header-foreground " + (selected ? "bg-planbuilder-workstream-header" : "bg-planbuilder-workstream-unselected") + " hover: cursor-pointer"} onClick={() => onClick(workstream)}>
                    <div className={"flex flex-col " + (showGannt ? " w-[675px]" : " w-[715px]")}>
                        <h2 className="flex  items-center" ><WorkstreamIcon className="m-2" />{workstream.name}</h2>
                    </div>
                    {!showGannt &&
                        <div className="flex flex-col min-w-[300px] w-full">
                            {showChart && <WorkstreamProgressChartRow planned={getPlannedPercentage()} actual={getActualPercentage()} actualColor='bg-chart-green' plannedColor='bg-green-800' />}
                        </div>}
                    <div className='flex items-center'>
                        {!showGannt && <div className="flex flex-col w-[175px]">{getDateRange()}</div>}
                        {workstream.workPackages.length != 0 && <button onClick={toggle} className="px-2 py-2 h-9">{open ? <ChevronUpIcon /> : <ChevronRightIcon />}</button>}
                    </div>
                    {showGannt &&
                        <GanttObj
                            startDate={getStartDate()}
                            finishDate={getFinishDate()}
                            color={selected ? "bg-planbuilder-workstream-header" : "bg-planbuilder-workstream-unselected"}
                        />}
                </div>)}
            <div className={(open || projectTypeId === 1 ? "" : " hidden")}>
                {workstream.workPackages.map((workpackage, index) => (
                    <WorkPackageContextMenu key={"wpcm" + workpackage.id}>
                        <WorkPackageObj
                            key={"wp" + workpackage.id}
                            workPackage={workpackage}
                            selected={props.selectedWorkpackageID === workpackage.id}
                            open={props.openWorkpackages?.includes(workpackage.id)}
                            showChart={showChart}
                            showGannt={showGannt}
                            index={index}
                            groupId={"ws" + workstream.id}
                        />
                    </WorkPackageContextMenu>
                ))}
            </div>
        </div>
    )
}

export default WorkstreamObj